module.exports = __webpack_public_path__ + "assets/img/page3-design-side-nav-expanded-5-e6010ff7.png";